import axiosInstance from './axiosInstance';

export const loginApi          = (data) => axiosInstance.post('/auth/login', data);
export const registerApi       = (data) => axiosInstance.post('/auth/register', data);
export const getMeApi          = ()     => axiosInstance.get('/auth/me');
export const verifyOTPApi      = (data) => axiosInstance.post('/auth/verify-otp', data);
export const resendOTPApi      = (data) => axiosInstance.post('/auth/resend-otp', data);
export const googleLoginApi    = (data) => axiosInstance.post('/auth/google', data);
